import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchDoctor } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const DoctorMultiSelector = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
}) => {
  const login = useSelector((state) => state?.jwtAuthreducer);
  const selectedDoctorIds = watch("doctor_id") || [];

  const { data: doctors, isLoading, error } = useQuery(
    ["doctors"],
    () => fetchDoctor({ payload: { ...login } }),
    {
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  const options = useMemo(
    () =>
      doctors?.data?.data?.map((doctor) => ({
        value: doctor.id,
        label: doctor.doctor_name,
      })) || [],
    [doctors]
  );

  // useEffect(() => {
  //   if (rowData && options.length) {
  //     const selectedOptions = options.filter((option) =>
  //       rowData?.doctor_ids?.some((item) => item.id === option.value)
  //     );
  //     if (selectedOptions.length) {
  //       const ids = selectedOptions.map((opt) => opt.value);
  //       const names = selectedOptions.map((opt) => opt.label);
  //       setValue("doctor_id", ids);
  //       setValue("doctor_name", names);
  //     }
  //   }
  // }, [rowData, options, setValue]);


  useEffect(() => {
    if (rowData?.doctors_data?.length && options.length) {
      const selectedOptions = options.filter((option) =>
        rowData?.doctors_data?.some((doc) => doc.id === option.value)
      );

      if (selectedOptions.length) {
        const ids = selectedOptions.map((opt) => opt.value);
        const names = selectedOptions.map((opt) => opt.label);
        setValue("doctor_id", ids);
        setValue("doctor_name", names);
      }
    }
  }, [rowData, options, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Doctor Data</div>;

  return (
    <Controller
      name="doctor_id"
      control={control}
      rules={{ required: required ? "At least one doctor is required" : false }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isMulti
          isClearable
          value={options.filter((option) =>
            selectedDoctorIds.includes(option.value)
          )}
          placeholder="Select Doctors"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              minHeight: "45px",
              maxHeight: "auto",
              overflowY: "auto",
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: "45px",
              overflowY: "auto",
            }),
            multiValue: (base) => ({
              ...base,
              maxWidth: "100%",
            }),
          }}
          onChange={(selectedOptions) => {
            const values = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
            const labels = selectedOptions ? selectedOptions.map((opt) => opt.label) : [];
            field.onChange(values);
            setValue("doctor_id", values);
            setValue("doctor_name", labels);
          }}
          className={`react-select-container ${errors.doctor_id ? "is-invalid" : ""}`}
        />
      )}
    />
  );
};

export default DoctorMultiSelector;
